import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-activated',
  templateUrl: './account-activated.component.html',
  styleUrls: ['./account-activated.component.css']
})
export class AccountActivatedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
